interface Dimensions {
  width: number;
  height: number;
}

interface CoverResult extends Dimensions {
  width: number;
  height: number;
  scale: number;
}

/**
 * Calculates the dimensions and scale needed to cover a container with content
 * while maintaining aspect ratio. This may crop parts of the content.
 */
export default function cover(content: Dimensions, container: Dimensions): CoverResult {
  const contentRatio = content.width / content.height;
  const containerRatio = container.width / container.height;

  let width: number;
  let height: number;
  let scale: number;

  if (contentRatio > containerRatio) {
    height = container.height;
    width = height * contentRatio;
    scale = height / content.height;
  } else {
    width = container.width;
    height = width / contentRatio;
    scale = width / content.width;
  }

  return {
    width,
    height,
    scale,
  };
}
